<div *ngIf="type==1" >
<div *ngIf="list!=null">
<div class=" border">
  <div class="padding-10" fxLayout="row">
    <b class="f20" style="font-size: 16px">{{title}}
    </b>
  </div>
  <mat-divider></mat-divider>
  <div>
    <div class="padding-10">
      <div>
        <div *ngFor="let item of list | keyvalue" fxLayout="row">
          <div fxFlex.gt-md="35" fxFlex.md="50" fxFlex.lt-md="50">
            <span class="colorGy">{{item.key.replace('_', ' ') }}</span>
          </div>
          <div fxLayout="row" fxFlex>
            <p class="blackColor wordBreak">{{item.value}} </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
</div>

  <div *ngIf="type==2" >
    <div *ngIf="list!=null">
    <div class="padding-10">
      <div class="padding-10" fxLayout="row">
        <b class="f20" style="font-size: 16px">{{title}}
        </b>
      </div>
      <div>
        <div class="padding-10">
          <div>
            <div *ngFor="let item of list | keyvalue" fxLayout="row">
              <div fxFlex.gt-md="35" fxFlex.md="50" fxFlex.lt-md="50">
                <span class="colorGy">{{item.key.replace('_', ' ') }}</span>
              </div>
              <div fxLayout="row" fxFlex>
                <p class="blackColor wordBreak">{{item.value}} </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>